<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      :option-label="(item) => `${item.firstName} ${item.lastName}`"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="loading"
      :options="options"
      @filter="filterFn"
      :clearable="clearable"
      @input="$emit('changed', model)"
      :dark="dark"
      :color="color"
    >
      <template
        v-slot:option="{ itemProps, opt, selected, toggleOption, itemEvents }"
      >
        <q-item @click="toggleOption(opt)" v-bind="itemProps" v-on="itemEvents">
          <q-item-section>

            <q-item-label>
              {{ opt.firstName }} {{ opt.lastName }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: "Search",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    data: {
      default: []
    },
    loading: {
      default: false
    }

  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  watch: {
    id: function () {
      this.init();
    },
    members: function () {
      this.init();
    },
    specificMembers: function () {
      this.init();
    },
  },
  data: () => ({
    model: null,
    options: [],
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.options = JSON.parse(
        JSON.stringify(
          this.data
        )
      );
      this.model = this.id;
      this.$forceUpdate();
    },
    filterFn(val, update) {
      if (val === "") {
        update(() => {
          this.options = JSON.parse(
            JSON.stringify(
              this.data
            )
          )
        });
        return;
      } else {
        update(() => {
          const needle = val.toLowerCase();
          let members = this.data;
          this.options = members.filter((v) => {
            let textMatch =
              `${v.firstName} ${v.lastName} ${v.crm_id}`
                .toLowerCase()
                .indexOf(needle) > -1;


            return textMatch;
          });
        });
      }
    },
  },
};
</script>
